module.exports = __webpack_public_path__ + "static/img/icon1.8ee85ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/icon1.png
// module id = Cj19
// module chunks = 1